import { getAction, getActionBlob, deleteAction, putAction, postAction, httpAction, postTimeOutAction } from '@/api/manage'

// 编码规则
const addCodeRule = (params) => postAction("/codeRules/fzRule/add", params) // 新增
const editCodeRule = (params) => postAction("/codeRules/fzRule/edit", params) // 编辑
const queryEnableDictItemsByCode = (params) => getAction("/codeRules/fzRule/queryEnableDictItemsByCode", params) // 获取下拉框
const queryDictItemsByType = (params) => getAction("/codeRules/fzNodeDictionary/queryDictItemsByType", params) // 获取字典ID
const queryDictDataByDictId = (params) => getAction("/codeRules/fzNodeDictionaryData/queryDictDataByDictId", params) // 获取字典具体值
// 规则节点
const ruleNodeList = (params) => getAction("/codeRules/fzRuleNode/list", params) // 获取列表
const addRuleNode = (params) => postAction("/codeRules/fzRuleNode/add", params) // 新增
const editRuleNode = (params) => postAction("/codeRules/fzRuleNode/edit", params) // 新增
// 生码
const beforeIdCode = (params) => getAction("/codeRules/fzIdcode/beforeIdCode", params) // 获取生码
const createIdCode = (params) => postAction("/codeRules/fzIdcode/createIdCode", params) // 完成生码
// 生码记录
const makeCodeRecordModalList = (params) => getAction("/codeRules/fzIdcodeBatch/list", params) // 获取列表
// 生码列表
// const makeCodeRecordListModalList = (params) => getAction("/codeRules/fzIdcode/generating/list", params) // 获取列表
const makeCodeRecordListModalList = (params) => getAction("/codeRules/fzIdcode/detail/list", params) // 获取列表
const generatedDetailById = (params) => getAction("/codeRules/fzRule/query/generatedDetailById", params) // 获取数据

// 编码字典
const addCodeDict = (params) => postAction("/codeRules/fzNodeDictionary/add", params) // 新增
const editCodeDict = (params) => postAction("/codeRules/fzNodeDictionary/edit", params) // 编辑
const editCodeDictData = (params) => postAction("/codeRules/fzNodeDictionaryData/edit", params) // 编辑
// 字典配置
const dictList = (params) => getAction("/codeRules/fzNodeDictionaryData/page", params) // 获取列表
const addDict = (params) => postAction("/codeRules/fzNodeDictionaryData/add", params) // 新增

export {
  editCodeDictData,
  // 规则编码
  addCodeRule, // 新增
  editCodeRule, // 编辑
  queryEnableDictItemsByCode, // 获取下拉框
  queryDictItemsByType, // 获取字典ID
  queryDictDataByDictId, // 获取字典具体值
  // 规则节点
  ruleNodeList, // 获取列表
  addRuleNode, // 新增
  editRuleNode, // 编辑
  // 生码
  beforeIdCode, // 获取生码
  createIdCode, // 完成生码
  // 生码记录
  makeCodeRecordModalList, // 获取列表
  // 生码列表
  makeCodeRecordListModalList, // 获取列表
  generatedDetailById, // 获取数据

  // 编码字典
  addCodeDict, // 新增
  editCodeDict, // 编辑
  // 字典配置
  dictList, // 获取列表
  addDict // 新增
}